// @view/FinalEdits.tsx
import React from "react";
import * as styles from "@styles/FinalEdits.css";
import type { DocumentFinalEditsViewProps } from "@ps-bridge/contracts/documentFinalEdits";
import * as IO from "@ps-bridge/interop/io";
import { ok } from "@ps-bridge/ok";
import { useDocumentAssistantDictation } from "@hooks/useDocumentAssistantDictation";
import DocumentAssistantDictationControl from "@view/document/DocumentAssistantDictationControl";

const FinalEditsComponent: React.FC<DocumentFinalEditsViewProps> = ({
  finalEdits,
  onFinalEditsChange,
  onSubmit,
}) => {
  const setFinalEditsValue = React.useCallback(
    (value: string) => IO.run(onFinalEditsChange(value)),
    [onFinalEditsChange],
  );
  const dictation = useDocumentAssistantDictation({
    fieldId: "finalEdits",
    value: finalEdits,
    setValue: setFinalEditsValue,
  });

  return (
    <div className={styles.container}>
      <p className={styles.header}>Manual Edits</p>
      <textarea
        ref={dictation.inputBindings.ref}
        data-testid="final-edits-input"
        className={styles.input}
        value={finalEdits}
        onChange={(event) => IO.run(onFinalEditsChange(event.target.value))}
        onClick={dictation.inputBindings.onClick}
        onFocus={dictation.inputBindings.onFocus}
        onSelect={dictation.inputBindings.onSelect}
        placeholder="Enter your edits here, the AI will be notified about your changes."
        rows={6}
      />
      <DocumentAssistantDictationControl
        {...dictation.controlState}
        buttonClassName={styles.button2}
        iconClassName=""
      />
      <button
        data-testid="final-edits-submit"
        className={styles.button2}
        onClick={() => IO.run(onSubmit(ok))}
      >
        Submit Edits
      </button>
    </div>
  );
};

export default FinalEditsComponent;
